export default __webpack_public_path__ + "static/SONY_WDRMODE_1_ALL_AUTO_NIGHT-411e5ef468eb73fef5ef1a1b2eb48153.webp";